import { Color, Vector4 } from 'three';
import { Palette, PalettedColor } from '../interfaces/planogram';
import { resolvePaletteColor } from './colors';

export function packShading(
  shading: PalettedColor = '#ffffff',
  opacity: number = 1,
  palette: Palette | undefined,
) {
  const result = new Vector4();
  const shadingColor = new Color(resolvePaletteColor(shading, palette));
  result.set(shadingColor.r, shadingColor.g, shadingColor.b, 1);
  result.setW(opacity);
  return result;
}
